import React, { useEffect, useState } from "react";
import { submitTypes } from "../../services/adminServices";
import auth from "../../services/authServices";
import { isMultiYear, isSubjectSubscriptionable } from "../../services/defaultSettings";
import http from "../../services/httpServices";
import InputIcon from "../../components/form/elements/InputIcon";
import { years } from "../../services/yearSevices";
import {
    handleCrud,
    handleFormSubmit,
    handleInputChange as handleChange,
    renderInputFields,
} from "../../services/formServices";
import AdminContainer from "../../components/ui/AdminContainer";
import AdminForm from "../../components/ui/AdminForm";
import { optionsOfDays } from "../../utils/ar";
const initialState = {
    year: 3,
    department_id: 0,
    study_planner_week_id: 0,
    day_name: "",
    name: "",
    branch: "",
    description: "",
    estimated_time: 0,
    break_time: 0,

    study_planner_subject_id: "",
    choosen_year: 3,
    choosen_department_id: 0,
    choosen_study_planner_week_id: 0,
    choosen_day_name: 0,
    submit_type: 0,
};

const StudyPlannerSubjectEditing = () => {
    const [data, setData] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [inputFields, setInputFields] = useState([]);
    const [studyPlannerSubjects, setStudyPlannerSubjects] = useState([]);

    const [departments, setDepartments] = useState([]);
    const [studyPlannerWeeks, setStudyPlannerWeeks] = useState([]);

    const getDepartments = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(
            `/api/admin/years/${
                data.submit_type !== "store" ? data.choosen_year : data.year
            }/departments/options`,
            config
        );
        setDepartments(response);
    };

    const getStudyPlannerWeeks = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);
        const { data: response } = await http.get(
            isSubjectSubscriptionable
                ? `/api/admin/departments/${
                      data.submit_type !== "store" ? data.choosen_department_id : data.department_id
                  }/study_planner_weeks/options`
                : `/api/admin/years/${
                      data.submit_type !== "store" ? data.choosen_year : data.year
                  }/study_planner_weeks/options`,
            config
        );
        setStudyPlannerWeeks(response);
    };

    const getStudyPlannerSubjects = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);
        const { data: response } = await http.get(
            `/api/admin/study_planner_weeks/${data.choosen_study_planner_week_id}/study_planner_subjects/options?day_name=${data.choosen_day_name}`,
            config
        );
        setStudyPlannerSubjects(response);
    };

    const getStudyPlannerSubjectInfo = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(
            `/api/study_planner_subjects/${data.study_planner_subject_id}`,
            config
        );
        let result = {};
        Object.keys(response).forEach((element) => {
            if (
                [
                    "day_name",
                    "department_id",
                    "study_planner_week_id",
                    "year",
                    "name",
                    "branch",
                    "description",
                    "estimated_time",
                    "break_time",
                ].includes(element)
            ) {
                result[element] = response[element];
            }
        });

        setData({ ...data, ...result });
    };

    useEffect(() => {
        if (
            data.submit_type &&
            data.submit_type !== "store" &&
            data.choosen_year &&
            (data.choosen_department_id || !isSubjectSubscriptionable) &&
            data.choosen_study_planner_week_id &&
            data.choosen_day_name
        ) {
            getStudyPlannerSubjects();
        }
        console.log(
            data.submit_type &&
                data.submit_type !== "store" &&
                data.choosen_year &&
                (data.choosen_department_id || !isSubjectSubscriptionable) &&
                data.choosen_study_planner_week_id &&
                data.choosen_day_name
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data.choosen_year,
        data.choosen_department_id,
        data.choosen_study_planner_week_id,
        data.choosen_day_name,
        data.submit_type,
    ]);

    useEffect(() => {
        if (
            (data.submit_type &&
                data.submit_type !== "store" &&
                data.choosen_year &&
                (data.choosen_department_id || !isSubjectSubscriptionable)) ||
            (data.submit_type &&
                data.submit_type === "store" &&
                data.year &&
                (data.department_id || !isSubjectSubscriptionable))
        ) {
            getStudyPlannerWeeks();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data.choosen_year,
        data.choosen_department_id,
        data.year,
        data.department_id,
        data.submit_type,
    ]);

    useEffect(() => {
        if (isSubjectSubscriptionable) {
            getDepartments();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.year, data.choosen_year, data.submit_type]);

    useEffect(() => {
        if (data.study_planner_subject_id > 0 && data.submit_type && data.submit_type !== "store") {
            getStudyPlannerSubjectInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.study_planner_subject_id, data.submit_type]);

    useEffect(() => {
        let fields = [
            {
                id: "submit_type",
                placeholder: "هتعمل ايه دلوقتي",
                type: "select",
                options: submitTypes,
            },
        ];

        if (data.submit_type) {
            if (data.submit_type && data.submit_type !== "store") {
                if (isMultiYear) {
                    fields = [
                        ...fields,
                        {
                            id: "choosen_year",
                            placeholder: "اختر الصف الدراسي",
                            type: "select",
                            options: years,
                        },
                    ];
                }

                if (isSubjectSubscriptionable) {
                    fields = [
                        ...fields,
                        {
                            id: "choosen_department_id",
                            placeholder: "اختر الشعبه",
                            type: "select",
                            options: departments,
                        },
                    ];
                }
                fields = [
                    ...fields,
                    {
                        id: "choosen_study_planner_week_id",
                        placeholder: "اختر الاسبوع",
                        type: "select",
                        options: studyPlannerWeeks,
                    },
                ];
                fields = [
                    ...fields,
                    {
                        id: "choosen_day_name",
                        placeholder: "اختر اليوم",
                        type: "select",
                        options: optionsOfDays,
                    },
                ];
                fields = [
                    ...fields,
                    {
                        id: "study_planner_subject_id",
                        placeholder: "اختر الماده",
                        type: "select",
                        options: studyPlannerSubjects,
                    },
                ];

                if (data.submit_type === "update") {
                    if (data.study_planner_subject_id > 0) {
                        fields = [
                            ...fields,
                            {
                                id: "name",
                                placeholder: "اسم الماده",
                                icon: <InputIcon icon="fluent:app-title-24-filled" />,
                            },
                            {
                                id: "branch",
                                placeholder: "اسم الحاجة اللي هتتذاكر / اسم الفرع",
                                icon: <InputIcon icon="fluent:app-title-24-filled" />,
                            },
                            {
                                id: "description",
                                placeholder: "وصف/ملاحظات الماده",
                                icon: <InputIcon icon="fluent:app-title-24-filled" />,
                                type: "textarea",
                            },
                            {
                                id: "estimated_time",
                                placeholder: "وقت المذاكره - بالدقائق",
                                icon: <InputIcon icon="fluent:app-title-24-filled" />,
                                type: "number",
                            },
                            {
                                id: "break_time",
                                placeholder: "وقت الراحه - بالدقائق",
                                icon: <InputIcon icon="fluent:app-title-24-filled" />,
                                type: "number",
                            },
                        ];
                    }
                }
            }

            if (data.submit_type && data.submit_type === "store") {
                if (isMultiYear) {
                    fields = [
                        ...fields,
                        {
                            id: "year",
                            placeholder: "اختر الصف الدراسي",
                            type: "select",
                            options: years,
                        },
                    ];
                }

                if (isSubjectSubscriptionable) {
                    fields = [
                        ...fields,
                        {
                            id: "department_id",
                            placeholder: "اختر الشعبه",
                            type: "select",
                            options: departments,
                        },
                    ];
                }
                fields = [
                    ...fields,
                    {
                        id: "study_planner_week_id",
                        placeholder: "اختر الاسبوع",
                        type: "select",
                        options: studyPlannerWeeks,
                    },
                ];
                fields = [
                    ...fields,
                    {
                        id: "day_name",
                        placeholder: "اختر اليوم",
                        type: "select",
                        options: optionsOfDays,
                    },
                ];
                fields = [
                    ...fields,
                    {
                        id: "name",
                        placeholder: "اسم الماده",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                    },
                    {
                        id: "branch",
                        placeholder: "اسم الحاجة اللي هتتذاكر / اسم الفرع",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                    },
                    {
                        id: "description",
                        placeholder: "وصف/ملاحظات الماده",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                        type: "textarea",
                    },
                    {
                        id: "estimated_time",
                        placeholder: "وقت المذاكره - بالدقائق",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                        type: "number",
                    },
                    {
                        id: "break_time",
                        placeholder: "وقت الراحه - بالدقائق",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                        type: "number",
                    },
                ];
            }
        }
        setInputFields(fields);
    }, [
        data.submit_type,
        data.year,
        data.department_id,
        data.study_planner_subject_id,
        data.choosen_year,
        data.choosen_department_id,
        data.choosen_study_planner_week_id,
        departments,
        studyPlannerWeeks,
        studyPlannerSubjects,
    ]);

    const handleSubmit = (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, () => {
            const adminToken = auth.getAdminToken();
            const config = auth.getAdminAuthConfig(adminToken);
            const crudApiEndPoint = "/api/study_planner_subjects";
            const crudItemName = "المادة";

            handleCrud(
                config,
                data,
                crudApiEndPoint,
                crudItemName,
                setIsLoading,
                setErrors,
                setData,
                initialState,
                data.study_planner_subject_id
            );
        });
    };

    return (
        <AdminContainer>
            <AdminForm
                onSubmit={handleSubmit}
                isLoading={isLoading}
                buttonText="auto"
                submitType={data.submit_type}
            >
                {inputFields.map((input, key) =>
                    renderInputFields(
                        key,
                        input.handleChange ? input.handleChange : handleChange,
                        data,
                        setData,
                        errors,
                        input
                    )
                )}
            </AdminForm>
        </AdminContainer>
    );
};

export default StudyPlannerSubjectEditing;
